import { gql, useQuery } from '@apollo/client';
import { Stack, Text } from '@chakra-ui/react';
import * as React from 'react';

import { AttachmentDisplayEvent } from '@/components/AttachmentDisplayEvent';
import { Card } from '@/imports/ui/chakra/components/Card';
import { AttachmentDisplayEvent_VersionFileFragment } from '../AttachmentDisplayEvent/graphql-types/AttachmentDisplayEvent_VersionFileFragment';

const EVENT_ATTACHMENTS_QUERY = gql`
  query EventAttachmentsCard_VersionFiles(
    $input: VersionFilesByIdsForAiAskInput!
  ) {
    versionFilesByIdsForAiAsk(input: $input) {
      results {
        ...AttachmentDisplayEvent_VersionFileFragment
      }
    }
  }
  ${AttachmentDisplayEvent.versionFileFragment}
`;

type EventAttachmentsQuery = {
  versionFilesByIdsForAiAsk: {
    results: (AttachmentDisplayEvent_VersionFileFragment | null)[];
  } | null;
};

type EventAttachmentsQueryVariables = {
  input: {
    versionFileIds: string[];
  };
};

export const EventAttachmentsCard: React.FC<{
  attachmentIds: string[];
  title?: string;
}> = ({ attachmentIds, title }) => {
  const { data, loading, error } = useQuery<
    EventAttachmentsQuery,
    EventAttachmentsQueryVariables
  >(EVENT_ATTACHMENTS_QUERY, {
    variables: { input: { versionFileIds: attachmentIds } },
    skip: attachmentIds.length === 0,
  });

  if (attachmentIds.length === 0) {
    return null;
  }

  return (
    <Card p="6">
      <Stack spacing="4">
        {title ? <Text textStyle="xlBodyStrong">{title}</Text> : null}
        {loading ? (
          <Text color="gray.500" role="status" aria-live="polite">
            Loading attachments...
          </Text>
        ) : error ? (
          <Text color="red.500" role="alert">
            Unable to load attachments.
          </Text>
        ) : (
          <AttachmentDisplayEvent
            versionFiles={data?.versionFilesByIdsForAiAsk?.results ?? null}
          />
        )}
      </Stack>
    </Card>
  );
};
